import React from 'react';
import { Analytics } from "@vercel/analytics/react";
import { Header, Footer } from "./LandingPage"; 
import SEO from './common/SEO';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col relative">
      <SEO path="/terms-of-service" />
      <Header />
      <main className="flex-1 pt-24">
        <div className="container max-w-3xl mx-auto px-4">
          <div className="space-y-8">
            <div className="flex flex-col items-center space-y-4">
              <img 
                src="/currents-logo.png"
                alt="Currents Logo" 
                className="w-16 h-16 rounded-2xl shadow-lg"
              />
              <h1 className="text-3xl font-bold">Currents Terms of Service</h1>
              <p className="text-sm text-gray-600">Last updated: 18 July 2024</p>
            </div>

            <section>
              <h2 className="text-2xl font-semibold mb-2">1. Acceptance of Terms</h2>
              <p>By accessing or using the Currents mobile application (&quot;the App&quot;), you agree to be bound by these Terms of Service (&quot;Terms&quot;). If you disagree with any part of the terms, you may not access the App.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">2. Description of Service</h2>
              <p>Currents is a social dive logging app that allows users to record dive experiences, manage certifications, explore dive locations, and connect with other divers.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">3. User Accounts</h2>
              <p>3.1. You must create an account to use certain features of the App. You are responsible for maintaining the confidentiality of your account and password.</p>
              <p>3.2. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">4. User Content</h2>
              <p>4.1. You retain all rights to your content. You control who can see your content through the app&apos;s sharing settings. You grant Currents permission to store and display your content to the users you choose to share it with, and to use it to provide and improve the app&apos;s features. Currents will not use your content for any other purpose without your explicit consent.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">5. Acceptable Use</h2>
              <p>You agree not to use the App to:</p>
              <ul className="list-disc list-inside ml-4">
                <li>Post or transmit any content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, or invasive of another&apos;s privacy.</li>
                <li>Impersonate any person or entity or falsely state or otherwise misrepresent your affiliation with a person or entity.</li>
                <li>Interfere with or disrupt the App or servers or networks connected to the App.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">6. Intellectual Property</h2>
              <p>The App and its original content, features, and functionality are owned by Currents and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">7. Termination</h2>
              <p>We may terminate or suspend your account and bar access to the App immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">8. Limitation of Liability</h2>
              <p>Currents is provided by an individual developer. While we strive to offer a reliable and secure service, we cannot guarantee that the App will always function without disruptions, delay, or imperfections. Your use of the App is at your own risk.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">9. Disclaimer</h2>
              <p>Your use of the App is at your sole risk. The App is provided on an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis. The App is provided without warranties of any kind, whether express or implied.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">10. Governing Law</h2>
              <p>These Terms shall be governed and construed in accordance with the laws of the country in which the app developer resides, without regard to its conflict of law provisions.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">11. Changes to Terms</h2>
              <p>We reserve the right to modify or replace these Terms at any time. We will provide notice of any significant changes by posting the new Terms on this page and updating the &quot;Last Updated&quot; date. Your continued use of the App after any such changes constitutes your acceptance of the new Terms.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">12. Contact Us</h2>
              <p>If you have any questions about these Terms, please contact us at: <a href="mailto:hello@deepsealabs.co" className="text-blue-600 hover:underline">hello@deepsealabs.co</a></p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
      <Analytics />
    </div>
  );
};

export default TermsOfServicePage;